import { render, staticRenderFns } from "./SupplierColor.vue?vue&type=template&id=3ee2a38a&scoped=true&"
import script from "./SupplierColor.vue?vue&type=script&lang=js&"
export * from "./SupplierColor.vue?vue&type=script&lang=js&"
import style0 from "./SupplierColor.vue?vue&type=style&index=0&id=3ee2a38a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ee2a38a",
  null
  
)

export default component.exports